import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { TrackerService } from '../services/tracker.service';

@Directive({
  selector: '[trackElement]',
  standalone: true,
})
export class TrackElementDirective {
  @Input({ alias: 'trackElement', required: true })
  elementName!: string;

  /** Element's tag name */
  readonly elementType = this.elementRef.nativeElement.tagName;

  /**
   * List of Event names to track on the element.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Element#events
   */
  @Input()
  set trackEvents(events: string | string[]) {
    this._trackEvents = new Set(typeof events === 'string' ? [events] : events);
  }
  get trackEvents() {
    return Array.from(this._trackEvents);
  }
  private _trackEvents = new Set<string>(['click', 'mouseenter', 'mouseleave']);

  @Input()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  trackData?: any;

  constructor(
    private readonly elementRef: ElementRef<Element>,
    private readonly trackerService: TrackerService,
    private readonly router: Router
  ) {}

  @HostListener('click', [])
  private _onMouseClick(): void {
    if (!this._trackEvents.has('click')) return;

    this.trackerService
      .trackElementClick(this.elementName, this.elementType, this.router.url, this.trackData)
      .pipe(take(1))
      .subscribe();
  }

  @HostListener('mouseenter', [])
  private _onMouseEnter(): void {
    if (!this._trackEvents.has('mouseenter')) return;
    this.trackerService.startHover();
  }

  @HostListener('mouseleave', [])
  private _onMouseLeave(): void {
    if (!this._trackEvents.has('mouseleave')) return;
    this.trackerService.endHover(this.elementName, this.elementType, this.router.url);
  }
}
